<template>
  <transition :name="transitionName"
              @enter="handleEnter"
              @leave="handleLeave"
              appear>
    <div :class="classes"
         :style="styles"
         @click="clickBibble">
      <template v-if="moveType === 'rightToleft'">
        <!--<div :class="contentWithIcon">-->
        <!--<render-cell-->
        <!--:render="renderFunc"-->
        <!--&gt;</render-cell>-->
        <!--</div>-->
        <div class="bubble_container">
          <div>{{tipsType}}</div>
          <span class="bubble_title"
                :title="title"
                style="float: initial">{{title}}</span>
          <span class="bubble_action">{{action}}</span>
          <img :src="icon"
               style="vertical-align: middle" />
          <div v-if="volume && title != '电话方'"
               class="volume_progress">
            <div :style="{height: volume+'%'}"></div>
          </div>
        </div>
        <!--<a :class="[baseClass + '-close']" @click="close" v-if="closable">-->
        <!--<i class="ivu-icon ivu-icon-ios-close"></i>-->
        <!--</a>-->
      </template>
      <template v-if="moveType === 'leftToright'">
        <div :class="[baseClass + '-content']"
             ref="content">
          <div class="bubble_container">
            <img :src="icon"
                 style="vertical-align: middle;float: left;" />
            <span :title="title"
                  :class="tipsType=='msg'? 'bubble_title_msg':'bubble_title'">{{title}}</span>
            <span :style="{float:tipsType!='msg'?'left':'inherit',marginTop:tipsType!='msg'?'3px':'0px'}"
                  class="bubble_action">{{action}}</span>
          </div>
          <!--<div :class="[baseClass + '-content-text']" v-html="content"></div>-->
          <!--<div :class="[baseClass + '-content-text']">-->
          <!--<render-cell-->
          <!--:render="renderFunc"-->
          <!--&gt;</render-cell>-->
          <!--</div>-->
          <!--<a :class="[baseClass + '-close']" @click="close" v-if="closable">-->
          <!--<i class="ivu-icon ivu-icon-ios-close"></i>-->
          <!--</a>-->
        </div>
      </template>
    </div>
  </transition>
</template>
<script>
import RenderCell from '../render';
export default {
  components: {
    RenderCell
  },
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    locale: {
      type: String,
      default: ''
    },
    length: { type: Number },
    duration: {
      type: Number,
      default: 1.5
    },
    moveType: {
      type: String
    },
    tipsType: { type: String },
    title: {
      type: String,
      default: ''
    },
    closeReminder: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    action: {
      type: String
    },
    volume: { type: Number },
    withIcon: Boolean,
    render: {
      type: Function
    },
    hasTitle: Boolean,
    styles: {
      type: Object,
      default: function () {
        return {
          right: '50%'
        };
      }
    },
    closable: {
      type: Boolean,
      default: false
    },
    className: {
      type: String
    },
    name: {
      type: String,
      required: true
    },
    onClose: {
      type: Function
    },
    onClick: {
      type: Function
    },
    onMounted: {
      type: Function
    },
    transitionName: {
      type: String
    }
  },
  data () {
    return {
      withDesc: false
    };
  },
  computed: {
    baseClass () {
      return `${this.prefixCls}-notice`;
    },
    renderFunc () {
      return this.render || function () { };
    },
    classes () {
      return [
        this.baseClass,
        {
          [`${this.className}`]: !!this.className,
          [`${this.baseClass}-closable`]: this.closable,
          [`${this.baseClass}-with-desc`]: this.withDesc,
          // :class="tipsType=='msg'? 'bubble_title_msg':'bubble_title'"
          ['notice-content-left-tips']: this.tipsType != 'msg' && this.moveType == 'leftToright',
          ['setBubbleEnStyle']: this.locale == 'en'
        }
      ];
    },
    contentClasses () {
      return [
        `${this.baseClass}-content`,
        this.render !== undefined ? `${this.baseClass}-content-with-render` : ''
      ];
    },
    contentWithIcon () {
      return [
        this.withIcon ? `${this.prefixCls}-content-with-icon` : '',
        !this.hasTitle && this.withIcon ? `${this.prefixCls}-content-with-render-notitle` : ''
      ];
    },
    messageClasses () {
      return [
        `${this.baseClass}-content`,
        this.render !== undefined ? `${this.baseClass}-content-with-render` : ''
      ];
    }
  },
  methods: {
    clearCloseTimer () {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    },
    clickBibble () {
      this.onClick();
    },
    close () {
      this.clearCloseTimer();
      this.onClose();
      this.$parent.close(this.name);
    },
    handleEnter (el) {
      if (this.type === 'message') {
        el.style.height = el.scrollHeight + 'px';
      }
    },
    handleLeave (el) {
      if (this.type === 'message') {
        // 优化一下，如果当前只有一个 Message，则不使用 js 过渡动画，这样更优美
        if (document.getElementsByClassName('ivu-message-notice').length !== 1) {
          el.style.height = 0;
          el.style.paddingTop = 0;
          el.style.paddingBottom = 0;
        }
      }
    },
    closeTips () {
      bus.$emit('closeTips')
    },
  },
  mounted () {
    this.clearCloseTimer();
    if (this.duration !== 0) {
      this.closeTimer = setTimeout(() => {
        this.close();
      }, this.duration * 1000);
    }

    this.onMounted(this.name)
    // check if with desc in Notice component
    // if (this.prefixCls === 'ivu-notice') {
    //     let desc = this.$refs.content.querySelectorAll(`.${this.prefixCls}-desc`)[0];
    //     this.withDesc = this.render ? true : (desc ? desc.innerHTML !== '' : false);
    // }
  },
  beforeDestroy () {
    this.clearCloseTimer();
  }
};
</script>
<style>
.bubble_Tips .notice-content-left-tips {
  width: 130px;
}
.volume_progress {
  position: absolute;
  right: 13px;
  top: 13px;
  width: 7px;
  height: 9px;
}
.setBubbleEnStyle {
  max-width: 242px !important;
  width: fit-content !important;
}
.setBubbleEnStyle .bubble_title {
  width: 40px !important;
}
.volume_progress div {
  background: #6089bf;
  position: absolute;
  width: 100%;
  max-height: 90%;
  bottom: 0px;
  border-radius: 0px 0px 10px 10px;
}
</style>
